import { GridRows, type GridScale } from "@visx/grid";
import { FC } from "react";

interface ChartGridLinesProps {
  valueScale: GridScale;
  xMax: number;
  strokeColor: string;
  desiredTickCount: number;
}

export const ChartGridLines: FC<ChartGridLinesProps> = ({
  valueScale,
  xMax,
  strokeColor,
  desiredTickCount,
}) => (
  <GridRows
    scale={valueScale}
    numTicks={desiredTickCount}
    width={xMax}
    stroke={strokeColor}
    strokeWidth={1}
    strokeDasharray="3,3"
  />
);
